import { Coordinates } from "@/types";
import { ref } from "vue";
import useToast from "./useToast";
import { useMapFilterStore } from "@/store/useMapFilterStore";
import { storeToRefs } from "pinia";
import moment from "moment";

export default function useGeolocation() {
    const geolocationOptions = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 180000, // 3 minutos
    };

    const mapFilterStore = useMapFilterStore()
    const { lastUserLocation } = storeToRefs(mapFilterStore)
    const { saveUserLastLocation } = mapFilterStore
    const isLocationAvailable = () => "geolocation" in navigator
    const { toastError } = useToast()
    const isPermissionEnabled = ref()

    // Variável para evitar chamadas múltiplas simultâneas
    let pendingLocationPromise: Promise<Coordinates | null> | null = null

    const getUserLocation = async (): Promise<Coordinates | null> => {
        // Se já tem uma promise pendente, retorna ela (evita chamadas duplicadas)
        if (pendingLocationPromise) {
            console.log('Reusando promise pendente de localização')
            return pendingLocationPromise
        }

        if (lastUserLocation.value?.coords) {
            const wasMeasuredLessThan2MinsAgo = Math.abs(moment().diff(lastUserLocation.value.timestamp, 'minutes')) <= 2
            if (wasMeasuredLessThan2MinsAgo) {
                console.log('Localização salva há menos de dois minutos')
                return lastUserLocation.value.coords
            }
            console.log('Localização salva há mais de dois minutos')
        } else {
            console.log('Não tem location salva')
        }

        // Armazena a promise para reusar se houver chamadas simultâneas
        pendingLocationPromise = getGeolocation()

        try {
            return await pendingLocationPromise
        } finally {
            pendingLocationPromise = null
        }
    }

    const getGeolocation = (): Promise<Coordinates | null> => {
        console.log('Buscando com o geolocation')
        return new Promise(resolve => {
            if (!isLocationAvailable()) {
                toastError('Verifique se a localização está habilitada no seu dispositivo.')
                console.log('Localizacao não disponível, isLocationAvailable false')
                resolve(null)
            }
            navigator.geolocation.getCurrentPosition((position) => {
                const response: Coordinates = { lat: position.coords.latitude, lng: position.coords.longitude }
                saveUserLastLocation(response)
                console.log('locloc', position)
                resolve(response)
            }, (error) => {
                // Mensagens específicas por tipo de erro
                switch(error.code) {
                    case 1: // PERMISSION_DENIED
                        toastError('Permissão de localização negada. Habilite nas configurações do navegador.')
                        break
                    case 2: // POSITION_UNAVAILABLE
                        toastError('Localização não disponível. Verifique se o GPS está ativo.')
                        break
                    case 3: // TIMEOUT
                        toastError('Tempo esgotado ao obter localização. Tente novamente.')
                        break
                    default:
                        toastError('Erro ao obter sua localização. Tente novamente')
                }
                console.log('Erro ao obter localização ' + error.code + ' ' + error.message)
                resolve(null)
            }, geolocationOptions);
        })
    }

    return {
        lastUserLocation,
        getUserLocation,
        isPermissionEnabled,
        geolocationOptions,
        saveUserLastLocation
        // checkUserPermission
    }
}

// TODO: ver o tamanho dos icones pra android
// TODO: ver o splash screen do android
